import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { usersAPI, memberAPI, partnerAPI } from '../services/api'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/Landing.vue')
  },
  {
    path: '/schools',
    name: 'Schools',
    component: () => import('../views/Schools.vue'),
    meta: { public: true }
  },
  {
    path: '/schools/:slug',
    name: 'SchoolDetail',
    component: () => import('../views/SchoolDetail.vue'),
    meta: { public: true }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue'),
    meta: { public: true }
  },
  {
    path: '/news/category/:category',
    name: 'NewsCategory',
    component: () => import('../views/News.vue'),
    meta: { public: true }
  },
  {
    path: '/news/tag/:tag',
    name: 'NewsTag',
    component: () => import('../views/News.vue'),
    meta: { public: true }
  },
  {
    path: '/news/:slug',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue'),
    meta: { public: true }
  },
  {
    path: '/patronat',
    name: 'Patronat',
    component: () => import('../views/Patronat.vue'),
    meta: { public: true }
  },
  {
    path: '/pay',
    name: 'PayPublic',
    component: () => import('../views/PayPublic.vue'),
    meta: { public: true }
  },
  {
    path: '/pay/status',
    name: 'PayStatus',
    component: () => import('../views/PayStatus.vue'),
    meta: { public: true }
  },
  {
    path: '/pay/:serviceCode',
    name: 'PayPublicWithService',
    component: () => import('../views/PayPublic.vue'),
    meta: { public: true }
  },
  {
    path: '/votes/:slug',
    name: 'VotePublic',
    component: () => import('../views/VotePublic.vue'),
    meta: { public: true }
  },
  {
    path: '/votes/:slug/results',
    name: 'VoteResults',
    component: () => import('../views/VoteResults.vue'),
    meta: { public: true }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Terms.vue'),
    meta: { public: true }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue'),
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue')
  },
  {
    path: '/member/login',
    name: 'MemberLogin',
    component: () => import('../views/member/MemberLogin.vue')
  },
  {
    path: '/app',
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AppMenu',
        component: () => import('../views/AppMenu.vue')
      },
      {
        path: 'schools',
        name: 'MySchools',
        component: () => import('../views/MySchools.vue')
      },
      {
        path: 'schools/add',
        redirect: '/app/schools'
      },
      {
        path: 'schools/create',
        name: 'CreateSchool',
        component: () => import('../views/CreateSchool.vue')
      },
      {
        path: 'schools/:schoolId/edit',
        name: 'EditSchool',
        component: () => import('../views/CreateSchool.vue')
      },
      {
        path: 'schools/:schoolId',
        name: 'SchoolDetailApp',
        component: () => import('../views/SchoolDetailApp.vue')
      },
      {
        path: 'schools/:schoolId/services/:serviceId',
        name: 'ServiceDetail',
        component: () => import('../views/ServiceDetailPlaceholder.vue')
      },
      {
        path: 'payment/status',
        name: 'AppPaymentStatus',
        component: () => import('../views/AppPaymentStatus.vue')
      },
      {
        path: 'connected-services',
        name: 'ConnectedServices',
        component: () => import('../views/ConnectedServices.vue')
      },
      {
        path: 'trainings',
        name: 'Trainings',
        component: () => import('../views/training/Trainings.vue')
      },
      {
        path: 'trainings/:slug',
        name: 'TrainingDetail',
        component: () => import('../views/training/TrainingDetail.vue')
      },
      {
        path: 'my-path',
        name: 'MyTrainingPath',
        component: () => import('../views/training/MyTrainingPath.vue')
      },
      {
        path: 'badges',
        name: 'Badges',
        component: () => import('../views/training/Badges.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue')
      },
      {
        path: 'news',
        name: 'AppNews',
        component: () => import('../views/app/AppNews.vue')
      },
      {
        path: 'news/:slug',
        name: 'AppNewsDetail',
        component: () => import('../views/app/AppNewsDetail.vue')
      },
    ]
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../views/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/accounts',
    name: 'AdminAccounts',
    component: () => import('../views/admin/AdminAccounts.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/schools',
    name: 'AdminSchools',
    component: () => import('../views/admin/AdminSchools.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/schools/:id',
    name: 'AdminSchoolDetail',
    component: () => import('../views/admin/AdminSchoolDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('../views/admin/AdminUsers.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/organizations',
    name: 'AdminOrganizations',
    component: () => import('../views/admin/AdminOrganizations.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/services',
    name: 'AdminServices',
    component: () => import('../views/admin/AdminServices.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/services/:id',
    name: 'AdminServiceDetail',
    component: () => import('../views/admin/AdminServiceDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/services/:id/partner-packages',
    name: 'AdminServicePartnerPackages',
    component: () => import('../views/admin/AdminServicePartnerPackages.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/classrooms',
    name: 'AdminClassrooms',
    component: () => import('../views/admin/AdminClassrooms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/payments',
    name: 'AdminPayments',
    component: () => import('../views/admin/AdminPayments.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/partners',
    name: 'AdminPartners',
    component: () => import('../views/admin/AdminPartners.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/members',
    name: 'AdminMembers',
    component: () => import('../views/admin/AdminMembers.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/patronat',
    name: 'AdminPatronat',
    component: () => import('../views/admin/AdminPatronat.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news',
    name: 'AdminNews',
    component: () => import('../views/admin/AdminNews.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings',
    name: 'AdminTrainings',
    component: () => import('../views/admin/AdminTrainings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/categories',
    name: 'AdminTrainingCategories',
    component: () => import('../views/admin/AdminTrainingCategories.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/requests',
    name: 'AdminTrainingRequests',
    component: () => import('../views/admin/AdminTrainingRequests.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/tracking',
    name: 'AdminTrainingTracking',
    component: () => import('../views/admin/AdminTrainingTracking.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/:id/preview',
    name: 'AdminTrainingPreview',
    component: () => import('../views/admin/AdminTrainingPreview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/:id/stats',
    name: 'AdminTrainingStats',
    component: () => import('../views/admin/AdminTrainingStats.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/trainings/:id',
    name: 'AdminTrainingDetail',
    component: () => import('../views/admin/AdminTrainingDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/categories',
    name: 'AdminNewsCategories',
    component: () => import('../views/admin/AdminNewsCategories.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/authors',
    name: 'AdminNewsAuthors',
    component: () => import('../views/admin/AdminNewsAuthors.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/analytics',
    name: 'AdminNewsAnalytics',
    component: () => import('../views/admin/AdminNewsAnalytics.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/notifications',
    name: 'AdminNotifications',
    component: () => import('../views/admin/AdminNotifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/:id/preview',
    name: 'AdminNewsPreview',
    component: () => import('../views/admin/AdminNewsPreview.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/news/:id',
    name: 'AdminNewsDetail',
    component: () => import('../views/admin/AdminNewsDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member',
    name: 'MemberDashboard',
    component: () => import('../views/member/MemberDashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/schools',
    name: 'MemberSchools',
    component: () => import('../views/member/MemberSchools.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/schools/:id',
    name: 'MemberSchoolDetail',
    component: () => import('../views/member/MemberSchoolDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/schools/import',
    name: 'MemberSchoolImport',
    component: () => import('../views/member/MemberSchoolImport.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/services',
    name: 'MemberServices',
    component: () => import('../views/member/MemberServices.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/services/:id',
    name: 'MemberServiceDetail',
    component: () => import('../views/member/MemberServiceDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/payments',
    name: 'MemberPayments',
    component: () => import('../views/member/MemberPayments.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/member/partners',
    name: 'MemberPartners',
    component: () => import('../views/member/MemberPartners.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/partner/login',
    name: 'PartnerLogin',
    component: () => import('../views/partner/PartnerLogin.vue')
  },
  {
    path: '/partner',
    name: 'PartnerDashboard',
    component: () => import('../views/partner/PartnerLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'PartnerDashboardHome',
        component: () => import('../views/partner/PartnerDashboard.vue')
      },
      {
        path: 'services',
        name: 'PartnerServices',
        component: () => import('../views/partner/PartnerServices.vue')
      },
      {
        path: 'services/:id',
        name: 'PartnerServiceDetail',
        component: () => import('../views/partner/PartnerServiceDetail.vue')
      },
      {
        path: 'votes',
        name: 'PartnerVotes',
        component: () => import('../views/partner/PartnerVotes.vue')
      },
      {
        path: 'votes/:id',
        name: 'PartnerVoteDetail',
        component: () => import('../views/partner/PartnerVoteDetail.vue')
      },
      {
        path: 'votes/:id/edit',
        name: 'PartnerVoteEdit',
        component: () => import('../views/partner/PartnerVoteEdit.vue')
      },
      {
        path: 'votes/:id/candidates',
        name: 'PartnerVoteCandidates',
        component: () => import('../views/partner/PartnerVoteCandidates.vue')
      },
      {
        path: 'votes/:id/votes',
        name: 'PartnerVoteVotes',
        component: () => import('../views/partner/PartnerVoteVotes.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      if (to.path.startsWith('/admin')) next({ name: 'AdminLogin' })
      else if (to.path.startsWith('/member')) next({ name: 'MemberLogin' })
      else if (to.path.startsWith('/partner')) next({ name: 'PartnerLogin' })
      else next({ name: 'Login' })
      } else {
      const realm = store.state.realm || localStorage.getItem('realm');
      if (to.path.startsWith('/partner') && to.path !== '/partner/login' && realm !== 'partner') {
        next({ name: 'PartnerLogin' });
        return;
      }
      // Panel partenaire : charger le profil (nom, organisation) avant toute vue
      if (to.path.startsWith('/partner') && to.path !== '/partner/login') {
        const user = store.state.user;
        const hasPartnerProfile = user && (user.name || user.email);
        if (!hasPartnerProfile) {
          try {
            const res = await partnerAPI.getMe();
            const partner = res.data;
            if (partner) {
              store.commit('SET_USER', partner);
              store.commit('SET_REALM', 'partner');
            }
          } catch (e) {
            console.error('Failed to load partner profile', e);
          }
        }
      }
      // Panel membre : charger le profil (organisation) avant toute vue pour que toutes les requêtes aient le contexte
      if (to.path.startsWith('/member') && to.path !== '/member/login') {
        const user = store.state.user
        const hasOrg = user && user.organization && (user.organization.name || user.organization._id)
        if (!hasOrg) {
          try {
            const res = await memberAPI.getMe()
            const member = res.data
            if (member) {
              store.commit('SET_USER', member)
              store.commit('SET_REALM', 'member')
            }
          } catch (e) {
            console.error('Failed to load member profile', e)
          }
        }
      }
      // App utilisateur (WhatsApp) : s'assurer qu'on a le profil pour avoir userType, etc.
      if (to.path.startsWith('/app')) {
        const user = store.state.user
        if (!user) {
          try {
            const res = await usersAPI.getProfile()
            const me = res.data
            if (me) {
              store.commit('SET_USER', me)
              store.commit('SET_REALM', 'user')
            }
          } catch (e) {
            console.error('Failed to load user profile', e)
          }
        }
      }
      next()
    }
  } else {
    next()
  }
})

export default router
